export function extractModbusSharePublicToken(pathname: string): string | null {
  const m = /^\/modbus-device-view\/public\/([^/?#]+)\/?$/i.exec(pathname || "");
  return m ? decodeURIComponent(m[1]) : null;
}
